'use strict';

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	LibraryController.$inject = ['$q', '$translate', 'download', 'libraryService'];
	angular.module('app.open-data').component('library', {
		require: { app: "^app" },
		template: '<div style="padding: 2em 2em;" translate-namespace="library"><div class="container-fluid"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><ol class="breadcrumb pull-left"><li ng-repeat="breadcrumb in $ctrl.app.breadcrumbs"><a href="{{breadcrumb.url}}">{{breadcrumb.label}}</a></li><li><a ui-sref="open-data" translate-namespace="open-data" translate>.Municipal open data</a></li><li translate>.Library</li></ol><div class="pull-right"><login-widget></login-widget></div></div></div><div class="row"><div class="col-lg-3"><aside class="well well-sidebar"><div class="row"><div class="col-lg-6"><div class="form-group"><label for="form-field-from-date" translate>.Start Year</label><div class="input-group input-group-sm"><input id="form-field-from-date" type="text" class="form-control" uib-datepicker-popup="yyyy" is-open="$ctrl.uiConfig.from.isOpen" datepicker-options="$ctrl.uiConfig.from.options" ng-model="$ctrl.form.from" show-button-bar="false" close-text="Close" ng-click="$ctrl.uiConfig.from.open()" ng-change="$ctrl.onDateChange()" readonly> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$ctrl.uiConfig.from.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-lg-6"><div class="form-group"><label for="form-field-to-date" translate>.End Year</label><div class="input-group input-group-sm"><input id="form-field-to-date" type="text" class="form-control" uib-datepicker-popup="yyyy" is-open="$ctrl.uiConfig.to.isOpen" datepicker-options="$ctrl.uiConfig.to.options" ng-model="$ctrl.form.to" show-button-bar="false" ng-click="$ctrl.uiConfig.to.open()" ng-change="$ctrl.onDateChange()" readonly> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$ctrl.uiConfig.to.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-lg-12"><div class="btn-group btn-block" role="group" translate-namespace="open-data.download-button"><button type="button" class="btn btn-block btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span translate>.Download</span> <span class="caret"></span></button><ul class="dropdown-menu"><li><a data-ng-click="$ctrl.download(\'csv\')" translate>.CSV file</a></li><li><a data-ng-click="$ctrl.download(\'png\')" translate>.Image</a></li><li><a data-ng-click="$ctrl.download(\'svg\')" translate>.Vector image</a></li></ul></div></div></div></aside></div><div class="col-lg-9"><div class="panel panel-default panel-graph"><h4 class="title text-center" translate>.Library</h4><div class="subtitle text-center">{{$ctrl.subtitle}}</div><nvd3 class="nvd3-chart" options="$ctrl.uiConfig.chart.options" config="$ctrl.uiConfig.chart.config" api="$ctrl.uiConfig.chart.api" data="$ctrl.chart"></nvd3></div></div></div></div></div>',
		controller: LibraryController,
		controllerAs: '$ctrl'
	});

	function LibraryController($q, $translate, download, libraryService) {
		'ngInject';

		var $ctrl = this;

		////////////////

		$ctrl.$onInit = function () {

			/* UI Components configuration */
			$ctrl.translations = {};
			$ctrl.form = getFormModel();
			$ctrl.uiConfig = getUiComponentsConfiguration();

			$q.all({
				yearsRange: libraryService.getYearRange(),
				formDefaults: libraryService.getFormDefaults(),
				translations: getTranslations()
			}).then(function (resp) {

				/* Get translations */
				$ctrl.translations = initTranslations(resp.translations);

				/* Initialize components */
				$ctrl.uiConfig.setDatesRange(resp.yearsRange);

				/* Set form default values */
				$ctrl.form.setDefaults(resp.formDefaults, resp.yearsRange);
				$ctrl.form.toFilename();

				/* Update */
				updateChart();
			}).catch(function (resp) {
				console.error(resp);
			});
		};

		/**
   * 
   */
		$ctrl.download = function (type) {
			var $svg, data, filename;

			filename = $ctrl.form.toFilename(type);

			switch (type) {
				case 'csv':
					data = Papa.unparse(getChartData(), { quotes: true, delimiter: ';' });
					download.fromDataURL("data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(data), filename);
					break;
				case 'png':
					$svg = angular.element('.nvd3-chart > svg');
					svgAsPngUri($svg[0], { backgroundColor: '#ffffff' }, function (uri) {
						return download.fromDataURL(uri, filename);
					});
					break;
				case 'svg':
					$svg = angular.element('.nvd3-chart > svg');
					svgAsDataUri($svg[0], { backgroundColor: '#ffffff' }, function (uri) {
						return download.fromDataURL(uri, filename);
					});
					break;
			}
		};

		$ctrl.onDateChange = function () {
			updateChart();
		};

		/**
  * 
  */
		function updateChart() {

			libraryService.getEntries(moment($ctrl.form.from), moment($ctrl.form.to)).then(function (entries) {

				$ctrl.chart = [{ key: $ctrl.translations['Members'], values: entries.members }, { key: $ctrl.translations['Total books'], values: entries.total_books }, { key: $ctrl.translations['Books for lending'], values: entries.books_for_lending }, { key: $ctrl.translations['Lended books'], values: entries.lended_books }];

				setSubtitle();
			});
		}

		/**
   * 
   */
		function getChartData() {
			var data = [];

			angular.forEach($ctrl.chart, function (series, index) {
				var column;

				/* Add dates column */
				if (index == 0) {

					/* Create Dates column. Concatenate header with date values */
					column = _.concat($ctrl.translations['Date'], _.map(series.values, function (o) {
						return o.at.toISOString();
					}));
					data.push(column);
				}

				/* Create data column. Concatenate column name with values */
				column = _.concat(series.key, _.map(series.values, 'value'));
				data.push(column);
			});

			return _.unzip(data);
		}

		/**
   * 
   * @param {*} text 
   */
		function setSubtitle() {
			var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var _$ctrl$form = $ctrl.form,
			    from = _$ctrl$form.from,
			    to = _$ctrl$form.to,
			    fromYear = moment(from).format('YYYY'),
			    toYear = moment(to).format('YYYY');


			$ctrl.subtitle = text || fromYear + ' - ' + toYear;
		}

		/**
   * 
   */
		function getTranslations() {
			return $translate(['library.api-i18n:name', 'library.Date', 'library.Members', 'library.Total books', 'library.Books for lending', 'library.Lended books', 'library.1st Semester', 'library.2nd Semester']);
		}

		/**
   * 
   * @param {array} translations 
   */
		function initTranslations(translations) {
			_.each(translations, function (value, key, translations) {
				translations[key.replace('library.', '')] = value;
			});

			return translations;
		}

		/**
   * 
   */
		function getFormModel() {
			return {
				from: null,
				to: null,

				setDefaults: function setDefaults(defaults, yearsRange) {
					this.from = _.max([defaults.from, yearsRange.min]).toDate();
					this.to = _.min([defaults.to, yearsRange.max]).toDate();
				},

				toFilename: function toFilename(extension) {
					var fromYear = moment(this.from).format('YYYY'),
					    toYear = moment(this.to).format('YYYY');

					return $translate.instant('library.ui:filename', { fromYear: fromYear, toYear: toYear, extension: extension }, null, null, null);
				}
			};
		}

		/**
   * 
   */
		function getUiComponentsConfiguration() {

			var format = function format(date) {
				var text,
				    at = moment(date);

				text = at.format('M') == 1 ? $ctrl.translations['1st Semester'] : $ctrl.translations['2nd Semester'];

				return text + ' ' + at.format('YYYY');
			};

			return {
				from: {
					isOpen: false,
					options: { minMode: 'year', datepickerMode: 'year', minDate: null, maxDate: null },
					open: function open() {
						this.isOpen = true;
					}
				},
				to: {
					isOpen: false,
					options: { minMode: 'year', datepickerMode: 'year', minDate: null, maxDate: null },
					open: function open() {
						this.isOpen = true;
					}
				},
				setDatesRange: function setDatesRange(datesRanges) {
					this.to.options.minDate = datesRanges.min.toDate();
					this.to.options.maxDate = datesRanges.max.toDate();
					this.from.options.minDate = datesRanges.min.toDate();
					this.from.options.maxDate = datesRanges.max.toDate();
				},
				chart: {
					config: {
						deepWatchOptions: true,
						deepWatchData: true,
						deepWatchDataDepth: 1
					},
					options: {
						title: { enable: false },
						subtitle: { enable: false },
						chart: {
							type: 'multiBarChart',
							legend: { margin: { top: 10, right: 0, bottom: 20, left: 0 } },
							height: 550,
							duration: 500,
							showControls: false,
							useInteractiveGuideline: false,
							clipEdge: true,
							stacked: false,
							margin: { top: 50, right: 60, bottom: 60, left: 60 },
							x: function x(d) {
								return typeof d != 'undefined' ? new Date(d.at) : '';
							},
							y: function y(d) {
								return typeof d != 'undefined' ? d.value : '';
							},
							xAxis: { tickFormat: format },
							yAxis: { tickFormat: d3.format('d') }
						}
					}
				}
			};
		}
	}
})();